import React from 'react';
const RecruitmentLogo = React.memo(() => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 21.31 19.44" },
        React.createElement("path", { className: "svg-white", d: "M11.18,4.81a4.7,4.7,0,1,0-4.69,4.7A4.69,4.69,0,0,0,11.18,4.81Z" }),
        React.createElement("path", { className: "svg-white", d: "M10.42,10a6.41,6.41,0,0,1-3.93,1.34A6.47,6.47,0,0,1,2.54,10,5.6,5.6,0,0,0,0,14.65v4.79H13V14.65A5.62,5.62,0,0,0,10.42,10Z" }),
        React.createElement("polygon", { className: "svg-white", points: "21.31 2.62 18.69 2.62 18.69 0 16.59 0 16.59 2.62 13.97 2.62 13.97 4.72 16.59 4.72 16.59 7.34 18.69 7.34 18.69 4.72 21.31 4.72 21.31 2.62" })));
});
export default RecruitmentLogo;
